/* eslint no-undef: 0 */
export default (lang) => {
  // Good ol' jQuery...
  const single = $('.au-vacancies-single');
  if (single.length > 0) {
    const url = `//auinstallation28.cs.au.dk/${lang === 1 ? 'en/' : ''}global-content/emply/raw-html/`;
    $.get(url, (data) => {
      single.append(data);
    });
  }
};
